import React from "react"
import { Download } from "lucide-react"
import { Button } from "src/components/ui/button"
import { Input } from "src/components/ui/input"
import { DATE_PRESETS, presetToRange } from "../constants"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/components/ui/select"

export default function ReportFilters({
  filters,
  onFiltersChange,
  preset,
  onPresetChange,
  exportUrl,
  showSourceFilter = false,
  showByFilter = false,
  byValue,
  onByChange,
}) {
  function handlePreset(key) {
    onPresetChange(key)
    const range = presetToRange(key)
    onFiltersChange({ ...filters, ...range })
  }

  return (
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex rounded-md border border-slate-200 p-0.5">
          {DATE_PRESETS.map((p) => (
            <Button
              key={p.key}
              variant="ghost"
              onClick={() => handlePreset(p.key)}
              className={`h-auto rounded px-3 py-1 text-[13px] font-normal ${
                preset === p.key
                  ? "bg-[#ecebff] font-medium text-[#4f39f6] hover:bg-[#ecebff]"
                  : "text-slate-600 hover:bg-transparent hover:text-slate-800"
              }`}
            >
              {p.label}
            </Button>
          ))}
        </div>

        <div className="flex items-center gap-1.5 text-[13px] text-slate-500">
          <Input
            type="date"
            value={filters.from || ""}
            onChange={(e) => {
              onPresetChange(null)
              onFiltersChange({ ...filters, from: e.target.value })
            }}
            className="h-8 w-auto"
          />
          <span>to</span>
          <Input
            type="date"
            value={filters.to || ""}
            onChange={(e) => {
              onPresetChange(null)
              onFiltersChange({ ...filters, to: e.target.value })
            }}
            className="h-8 w-auto"
          />
        </div>

        {showSourceFilter && (
          <Select
            value={filters.source || "all"}
            onValueChange={(val) => onFiltersChange({ ...filters, source: val === "all" ? "" : val })}
          >
            <SelectTrigger className="w-[160px] h-9 text-[13px] text-slate-700 bg-white border-slate-300 focus:ring-1 focus:ring-slate-400">
              <SelectValue placeholder="All Sources" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Sources</SelectItem>
              {["channel_partner", "direct", "referral", "campaign", "walk_in", "qr_campaign"].map(
                (s) => (
                  <SelectItem key={s} value={s}>
                    {s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                  </SelectItem>
                )
              )}
            </SelectContent>
          </Select>
        )}

        {showByFilter && (
          <Select
            value={byValue || "none"}
            onValueChange={(val) => onByChange(val === "none" ? "" : val)}
          >
            <SelectTrigger className="w-[150px] h-9 text-[13px] text-slate-700 bg-white border-slate-300 focus:ring-1 focus:ring-slate-400">
              <SelectValue placeholder="No breakdown" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="none">No breakdown</SelectItem>
              <SelectItem value="source">By Source</SelectItem>
              <SelectItem value="project">By Project</SelectItem>
              <SelectItem value="rep">By Rep</SelectItem>
            </SelectContent>
          </Select>
        )}
      </div>

      {exportUrl && (
        <a href={exportUrl} download>
          <Button variant="outline" size="sm">
            <Download className="mr-1.5 h-4 w-4" />
            Export CSV
          </Button>
        </a>
      )}
    </div>
  )
}
